import assetsManifest from 'cryptocurrency-icons/manifest.json';

export const ASSETS_MANIFEST = [
  ...assetsManifest,
  {
    symbol: 'HUSD',
    name: 'HUSD',
    color: '#005ffa',
  },
  {
    symbol: 'USDK',
    name: 'USDK',
    color: '#0d74f6',
  },
  {
    symbol: 'sUSD',
    name: 'Synth sUSD',
    color: '#1e1a31',
  },
  {
    symbol: 'SAI',
    name: 'Single Collateral DAI',
    color: '#fec926',
  },
  {
    symbol: 'DAI',
    name: 'Multi-collateral DAI',
    color: '#f5ac37',
  },
  {
    symbol: 'BUSD',
    name: 'Binance USD',
    color: '#f0b90b',
  },
  {
    symbol: 'EURS',
    name: 'STASIS EURS Token',
    color: '#2468E4',
  },
  {
    symbol: 'AOA',
    name: 'Aurora',
    color: '#3cbdb4',
  },
  {
    symbol: 'CELR',
    name: 'CelerToken',
    color: '#000',
  },
  {
    symbol: 'LINK',
    name: 'ChainLink Token',
    color: '#2a5ada',
  },
  {
    symbol: 'CRO',
    name: 'Crypto.com Chain',
    color: '#103f68',
  },
  {
    symbol: 'DGTX',
    name: 'DigitexFutures',
    color: '#7b32e8',
  },
  {
    symbol: 'HPT',
    name: 'HuobiPoolToken',
    color: '#2a3069',
  },
  {
    symbol: 'LA',
    name: 'LATOKEN',
    color: '#151f38',
  },
  {
    symbol: 'LAMB',
    name: 'Lambda',
    color: '#4557e0',
  },
  {
    symbol: 'LBA',
    name: 'Cred',
    color: '#061845',
  },
  {
    symbol: 'MXM',
    name: 'Maximine Coin',
    color: '#65dae7',
  },
  {
    symbol: 'ORBS',
    name: 'Orbs',
    color: '#404a6e',
  },
  {
    symbol: 'QNT',
    name: 'Quant',
    color: '#25245f',
  },
  {
    symbol: 'QKC',
    name: 'QuarkChain Token',
    color: '#005fff',
  },
  {
    symbol: 'SNX',
    name: 'Synthetix Network Token',
    color: '#1e1a31',
  },
  {
    symbol: 'WaBi',
    name: 'Tael',
    color: '#FF5846',
  },
  {
    symbol: 'TOP',
    name: 'TOP Network',
    color: '#f8cf03',
  },
  {
    symbol: 'WBTC',
    name: 'Wrapped Bitcoin',
    color: '#595565',
  },
  {
    symbol: 'WETH',
    name: 'WETH',
    color: '#d93a79',
  },
  {
    symbol: 'LEO',
    name: 'UNUS SED LEO',
    color: '#11021e',
  },
  {
    symbol: 'UBT',
    name: 'Unibright',
    color: '#76b94f',
  },
  {
    symbol: 'NMR',
    name: 'Numeraire',
    color: '#11021e',
  },
  {
    symbol: 'OKB',
    name: 'OKB',
    color: '#235ed9',
  },
  {
    symbol: 'DGX',
    name: 'Digix Gold Token',
    color: '#e4c893',
  },
  {
    symbol: 'FET',
    name: 'Fetch.ai',
    color: '#202944',
  },
  {
    symbol: 'SEELE',
    name: 'Seele-N',
    color: '#000000',
  },
  {
    symbol: 'OMG',
    name: 'OMG Network',
    color: '#4967ff',
  },
  {
    symbol: 'COMP',
    name: 'Compound',
    color: '#00d395',
  },
  {
    symbol: 'FTT',
    name: 'FTX Token',
    color: '#7bcfe4',
  },
  {
    symbol: 'LEND',
    name: 'Aave',
    color: '#0fa9c9',
  },
  {
    symbol: 'MXC',
    name: 'MXC',
    color: '#008477',
  },
  {
    symbol: 'RSR',
    name: 'Reserve Rights',
    color: '#000',
  },
  {
    symbol: 'AMPL',
    name: 'Ampleforth',
    color: '#000',
  },
  {
    symbol: 'BZRX',
    name: 'bZx Protocol',
    color: '#003cda',
  },
  {
    symbol: 'PNK',
    name: 'Kleros',
    color: '#5b1ebf',
  },
  {
    symbol: 'BAL',
    name: 'Balancer',
    color: '#000',
  },
  {
    symbol: 'CHSB',
    name: 'SwissBorg',
    color: '#5dcca8',
  },
  {
    symbol: 'OCEAN',
    name: 'Ocean Protocol',
    color: '#000',
  },
  {
    symbol: 'GNO',
    name: 'Gnosis',
    color: '#00A6C4',
  },
  {
    symbol: 'MUSD',
    name: 'mStable USD',
    color: '#000',
  },
  {
    symbol: 'MTA',
    name: 'Meta',
    color: '#000',
  },
  {
    symbol: 'UMA',
    name: 'UMA',
    color: '#fe4a49',
  },
  {
    symbol: 'AST',
    name: 'AirSwap',
    color: '#2b71ff',
  },
  {
    symbol: 'IDX',
    name: 'Index Chain',
    color: '#004b6a',
  },
  {
    symbol: 'MLN',
    name: 'Melon',
    color: '#030303',
  },
  {
    symbol: 'PNT',
    name: 'pNetwork',
    color: '#ff6666',
  },
  {
    symbol: 'STAKE',
    name: 'xDai',
    color: '#4ba9a8',
  },
  {
    symbol: 'RENBTC',
    name: 'renBTC',
    color: '#aaa',
  },
  {
    symbol: 'SBTC',
    name: 'sBTC',
    color: '#6e97ff',
  },
  {
    symbol: 'IMBTC',
    name: 'The Tokenized Bitcoin',
    color: '#242441',
  },
  {
    symbol: 'BTC++',
    name: 'PieDAO BTC++',
    color: '#d6099c',
  },
  {
    symbol: 'USD++',
    name: 'PieDAO USD++',
    color: '#d6099c',
  },
  {
    symbol: 'YAM',
    name: 'YAM',
    color: '#dd7485',
  },
];
